import type { ValueFormatterParams } from "ag-grid-community";

import { InvoiceModeDisplay, InvoiceStatusDisplay } from "~/modules/accounting/invoice-status";

export const PaymentStatusCellRenderer = (params: ValueFormatterParams<string | null>) => {
  const value = params?.value || null;
  if (!value) {
    return null;
  }

  // Render invoice status badge when possible
  const INVOICE_STATUS_VALUES = ["DRAFT", "POSTED", "PARTIALLY_PAID", "PAID", "VOID"] as const;
  if ((INVOICE_STATUS_VALUES as readonly string[]).includes(value)) {
    return <InvoiceStatusDisplay status={value} />;
  }

  // Render consignment mode badge when flagged as consignment
  if (value === "CONSIGNMENT") {
    return <InvoiceModeDisplay invoiceMode={"CONSIGNMENT" as any} />;
  }

  return null;
};
